var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cls},[_c('el-scrollbar',{ref:"scrollview",staticStyle:{"height":"100%"}},[_vm._t("default"),_vm._v(" "),(_vm.toastText!=='')?_c('zui-toast',[_vm._v("\n\t\t\t"+_vm._s(_vm.toastText)+"\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.loadingVisible)?_c('zui-loading'):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fa1c336","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 1416
// module chunks = 0